<template>
  <div>
    <div class="debug-content" style="line-height: 18px; right: unset; left: 15px; top: 70px; width: 140px;"
         v-if="$store.state.displayDebug">
      <p v-for="(type, index) in $store.getters.types" :key="`type-${index}`"
         @click="$store.commit('UPDATE_SLIDE', index)"
         :class="`${$store.state.activeSlide === index ? 'active' : ''}`">{{ index }} - {{ type }}</p>
    </div>
    <div :class="`debug-content ${$store.state.displayDebug ? '' : 'shrinked'}`">
      <label class="switch new-debug-row">
        <input type="checkbox" id="debug-display-tools" @click="$store.commit('TOGGLE_DISPLAY_DEBUG')"
               :checked="!$store.state.displayDebug">
        <span class="slider round"></span>
      </label>
      Hide debug tools
    </div>
    <div class="debug-content" v-if="$store.state.displayDebug" style="top: 80px;">
      <label class="switch new-debug-row">
        <input type="checkbox" id="debug-time-weather" @click="$store.commit('TOGGLE_DEBUG_TIME_WEATHER')">
        <span class="slider round"></span>
      </label>
      Disable automatic day / night
      <br>
      <label class="switch new-debug-row">
        <input type="checkbox" id="debug-fix-slide" @click="$store.commit('TOGGLE_DEBUG_FIXED_SLIDE')">
        <span class="slider round"></span>
      </label>
      Disable automatic slides
      <br>
      <!--      <label class="switch new-debug-row">-->
      <!--        <input type="checkbox" id="debug-mock-data" @click="useMockData">-->
      <!--        <span class="slider round"></span>-->
      <!--      </label>-->
      <!--      Use mock data-->
      <!--      <br>-->

      <input type="number" class="new-debug-row" :value="$store.state.activeSlide" min="0"
             :max="$store.state.filteredSlides.length - 1"
             id="debug-slide-number"
             @change="$store.commit('UPDATE_SLIDE', parseInt($el.querySelector('#debug-slide-number').value))">
      <label for="debug-slide-number">Slide Number</label>
    </div>
    <div class="debug-content" style="top: 210px;" v-if="$store.state.displayDebug">
      Time before next refresh ({{ refreshTimeDisplay }}) : {{ timeDifference() }}
    </div>
    <div class="debug-content" style="top: 260px;" v-if="$store.state.displayDebug">
      Choose Date:
      <flat-pickr v-model="date" :config="config">
        <!--        <svg fill="#56BFCA" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 26 28" x="0px" y="0px">-->
        <!--          <path-->
        <!--            d="M2 26h4.5v-4.5h-4.5v4.5zM7.5 26h5v-4.5h-5v4.5zM2 20.5h4.5v-5h-4.5v5zM7.5 20.5h5v-5h-5v5zM2 14.5h4.5v-4.5h-4.5v4.5zM13.5 26h5v-4.5h-5v4.5zM7.5 14.5h5v-4.5h-5v4.5zM19.5 26h4.5v-4.5h-4.5v4.5zM13.5 20.5h5v-5h-5v5zM8 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM19.5 20.5h4.5v-5h-4.5v5zM13.5 14.5h5v-4.5h-5v4.5zM19.5 14.5h4.5v-4.5h-4.5v4.5zM20 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM26 6v20c0 1.094-0.906 2-2 2h-22c-1.094 0-2-0.906-2-2v-20c0-1.094 0.906-2 2-2h2v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h6v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h2c1.094 0 2 0.906 2 2z"></path>-->
        <!--        </svg>-->
      </flat-pickr>
      <button @click="updateDate">Submit</button>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import slides from '@/data/slides'

export default {
  name: 'Debug',
  data () {
    return {
      date: '',
      config: {
        enableTime: true,
        dateFormat: 'Y-m-d h:i K'
      },

      mockSlides: slides
    }
  },
  watch: {
    '$store.state.ymdhikDateTime' (newValue) {
      this.date = newValue
    }
  },
  components: { flatPickr },
  methods: {
    timeDifference () {
      const today = new Date(this.$store.state.dateTime)
      const refresh = new Date(this.$store.state.dateTime)
      refresh.setHours(parseInt(this.$store.state.reloadTime.split(':')[0]), parseInt(this.$store.state.reloadTime.split(':')[1]), parseInt(this.$store.state.reloadTime.split(':')[2]))

      if (today >= refresh) {
        refresh.setDate(refresh.getDate() + 1)
      }

      const msec = refresh - today
      const mins = Math.floor(msec / 60000)
      const hrs = Math.floor(mins / 60)

      return hrs + 'h ' + mins % 60 + 'min'
    },
    updateDate () {
      window.location.href = window.location.origin + '/#/debug?date=' + this.date.replace(/ /g, '_')
      window.location.reload()
    }
  },
  computed: {
    refreshTimeDisplay () {
      return `${parseInt(this.$store.state.reloadTime.split(':')[0])}${parseInt(this.$store.state.reloadTime.split(':')[1]) !== 0 ? (':' + ('0' + this.$store.state.reloadTime.split(':')[1]).slice(-2)) : ''}${parseInt(this.$store.state.reloadTime.split(':')[2]) !== 0 ? (':' + ('0' + this.$store.state.reloadTime.split(':')[2]).slice(-2)) : ''} ${parseInt(this.$store.state.reloadTime.split(':')[0]) >= 12 ? 'PM' : 'AM'}`
    }
  }
}
</script>

<style scoped>
  .debug-content {
    position: absolute;
    top: 15px;
    right: 15px;
    color: #56BFCA;
    background-color: white;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    border-radius: 25px;
    padding: 10px;
    z-index: 99999;
    width: 400px;
    max-height: 500px;
    overflow-y: scroll;
  }

  .debug-content.shrinked {
    width: 170px;
  }

  .debug-content p {
    margin: 0;
    padding: 0 5px;
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    -ms-transition: all 0.2s;
    -o-transition: all 0.2s;
    transition: all 0.2s;
    border: solid 1px transparent;
    background: transparent;
    border-radius: 4px;
  }

  .debug-content p:hover {
    cursor: pointer;
    background: pink;
    color: white;
  }

  .debug-content p.active {
    border: solid 1px #56BFCA;
    padding-left: 30px;
  }

  input {
    text-align: center;
    width: 40px;
    font-size: 16px;
    border-radius: 10px;
    border: solid 1px #56BFCA;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 43px;
    height: 22px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: #56BFCA;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #56BFCA;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(20px);
    -ms-transform: translateX(20px);
    transform: translateX(20px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 18px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .new-debug-row {
    margin: 5px 0;
  }

  .flatpickr-input {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Debug.vue